<template>
  <div>
    <tool-bar></tool-bar>
    <main><router-view :key="$route.fullPath"></router-view></main>
    <foot-bar></foot-bar>
  </div>
</template>

<script>
  import ToolBar from '@/components/ToolBar.vue';
  import FootBar from '@/components/FootBar.vue';
  import Vue from 'vue';
  import {mapState, mapMutations, mapActions} from 'vuex';

  export default {
    name: 'Index',
    components: {
      ToolBar,
      FootBar,
    },
    computed:{
        ...mapState(['empresa']),
    },
    data(){
        return{
            loadProperty:false,
            dataProperty:{
                company:{},
            },
        }
    },
    created(){
    },
    mounted(){
      this.getPropiedades();
    },
    methods:{
      ...mapMutations(['setLoading','setEmpresa']),
      getPropiedades(){
        this.$http.get('ws_principal/property_company').then((res)=>{
          this.setEmpresa(res.data.Institucion);
          this.setLoading(false);
        });
      }
    },
  }
</script>